import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

interface InstanceTypesResponse {
  instance_types: CF.API.Compute.InstanceType[];
}

export const listInstanceTypesTE = <E = CF.API.ApiError>(
  { cloudProviderId, region, params = '' }: { cloudProviderId: string; region: string; params?: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, InstanceTypesResponse> =>
  fetchTE<InstanceTypesResponse, E>(
    {
      path: `/api/_api/v2/cloud_providers/${cloudProviderId}/regions/${region}/instance_types${params ? `?${params}` : ''}`,
      method: 'GET',
    },
    onRejected,
  );
